import { constants } from 'src/constants/constants';

export class GlobalConstants {
  public static readonly tooltipShowDelay: number = 500;
  public static readonly tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  public static redirectUrlParam = 'redirectUrl';
  public static isActiveField = 'IsActive';
  public static appIdParam = 'appId';
  public static tokenParam = 'token';
  public static defaultContentType = 'application/json';
  public static dataTableHeaders = {
    start: 0,
    length: 100
  };
  public static customLogin = 'custom';
  public static readonly bnmVersion = 'v26051';
  public static googleLogin = 'google';
  public static tenantId = 'tenantId';
  public static transactionDbRdbms = 'RDBMS (Hibernate)';
  public static transactionDbNoSql = 'NoSQL';
  public static searchDbRdbms = 'RDBMS';
  public static searchDbEs = 'Elastic Search';
  public static searchable = 'searchable';
  public static dataModel = 'Data Model';
  public static notSearchable = 'Not Searchable';
  public static notIndexed = 'Not Indexed';
  public static numberMinVal = -9223372036854775808;
  public static numberMaxVal = '9223372036854775807';
  public static decimalMinVal = -2147483648;
  public static decimalMaxVal = -2147483648;
  public static concurrencyErrorMap = {
    '001': 'CONCURRENCY_ERROR1',
    '002': 'CONCURRENCY_ERROR2',
    '003': 'CONCURRENCY_ERROR3',
    '004': 'CONCURRENCY_ERROR4',
    '005': 'CONCURRENCY_ERROR5',
    '006': 'CONCURRENCY_ERROR6',
    '007': 'CONCURRENCY_ERROR7'
  };
  public static lookupType = 'Query View';
  public static lookupDisplayType = 'Dropdown';
  public static create = 'CREATE';
  public static update = 'UPDATE';
  public static delete = 'DELETE';
  
  // Source Data Type -> Supported Target Data Types
  // Eg: String source can map to string, dropdown, text, email target fields
  public static paramMappDataTyp = {
    string: ['string', 'dropdown', 'text', 'email'],
    number: ['number', 'auto-number'],
    double: ['double', 'currency'],
    dropdown: ['dropdown', 'radio', 'string', 'text'],
    datetime: ['datetime'],
    date: ['date'],
    boolean: ['boolean', 'checkbox'],
    checkbox: ['boolean', 'checkbox'],
    radio: ['dropdown', 'radio', 'string', 'text'],
    text: ['text', 'string'],
    'yes no': ['yes no', 'string'],
    currency: ['currency', 'double'],
    'auto-number': ['number'],
    email: ['email', 'string', 'text'],
    url: ['url', 'string', 'text'],
    color: ['color', 'string', 'text']
  };
  public static manualBefore = 'Manual before';
  public static manualAfter = 'Manual after';
  public static auto = 'Auto';
  public static url = 'URL';
  //public static rappitVersion = 'v25072';
  public static appCopyVersion = 'v25072';
  public static refsVersion = 'v26031';

  //public static rappitVersion = constants.v25072;
  public static rappitNosqlLink = constants.v23121;
  public static rappitNosqlLinkName = 'nosql-rappit-developer.rappit.io';
  public static dataTypeForeignkeyMap = {
    number: ['auto-number', 'number'],
    string: ['string', 'text', 'email'],
    double: ['double', 'currency'],
    dropdown: ['dropdown', 'radio'],
    datetime: ['datetime'],
    date: ['date'],
    boolean: ['boolean', 'checkbox'],
    checkbox: ['boolean', 'checkbox'],
    radio: ['dropdown', 'radio'],
    text: ['string', 'text', 'email'],
    'yes no': ['yes no'],
    checkboxgroup: ['checkboxgroup'],
    url: ['url'],
    currency: ['currency', 'double'],
    color: ['color'],
    'auto-number': ['number'],
    email: ['email']
  };
  public static documentLinkKeyword =
    'https://portal.document360.io/7474067c-0ddc-4906-b932-6d86fb681f97/document/rappit/view/418f1c2d-199d-4b82-bd69-e2403ecd445a';
  public static auditFields = ['Created By', 'Created Date', 'Modified By', 'Modified Date', 'Sync Time'];
  public static pageVariableMap = {
    STRING: 'String',
    NUMBER: 'Number',
    DOUBLE: 'Double',
    DATE_TIME: 'DateTime',
    DATE_ONLY: 'Date',
    EMAIL: 'Email',
    BOOLEAN: 'Boolean'
  };
  public static domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  public static maximumDomain = 25;
  public static domainMaxLength = 253;
  public static domainLabelMaxLength = 63;
  public static apiCallBatchSize = 10000;
  public static isAppMetaInfoPopulated = 'isAppMetaInfoPopulated';
  public static isAppUserMetaInfoPopulated = 'isAppUserMetaInfoPopulated';
  public static yesNoRegex = /^(yes|no)$/i;
  public static dateTimeRegex = /[T\s]\d{1,2}:\d{2}/;

  // Branch Management Constants
  public static readonly defaultPageSize = 50;
  public static readonly scrollDebounceMs = 300;
  public static readonly defaultColorSaturation = 50;
  public static readonly defaultColorLightness = 50;
  public static readonly defaultDateDisplayFormat = 'MMM d, yyyy';
  public static readonly defaultDateTimeDisplayFormat = 'MMM d, yyyy, h:mm a';
  public static readonly dateFormat = 'mm/dd/yy';
  public static readonly hourFormat = '12';
  // Query String Constants
  public static queryStringRegex = {
    /** Matches $${...} pattern including empty braces */
    chipPattern: /\$\$\{([^}]*)\}/g,
    /** Matches $${...} pattern with non-empty content */
    chipPatternNonEmpty: /\$\$\{([^}]+)\}/g,
    /** Monaco editor regex string for matching $${...} */
    monacoChipPattern: '\\$\\$\\{([^\\}]*)\\}',
    /** Monaco Monarch tokenizer regex for matching $${...} */
    monarchTokenizerPattern: /\$\$\{[^}]*\}/,
    /** Regex for newlines, tabs, and multiple spaces - used for query formatting */
    newlinePattern: /\r\n|\r|\n/g,
    tabPattern: /\t/g,
    multiSpacePattern: /\s+/g,
    /** Regex to check for whitespace */
    whitespacePattern: /\s/,
    /** Regex for special characters not allowed in query string name */
    specialCharsPattern: /[^a-zA-Z0-9_\s-]/,
    /** Check for querystring occurrence */
    qStringMatchPattern: /\$\$\{([^}]+)\}/g,
    /** Regex to eliminate unnecessaary spaces */
    trimPattern: /\r\n/g
  };

  public static queryStringConfig = {
    /** Maximum length for query string name */
    maxNameLength: 150,
    /** Timeout for waiting for appGlobalService data to populate (in ms) */
    dataPopulationTimeout: 500,
    /** Tooltip cache size limit */
    tooltipCacheLimit: 100,
    /** Default pagination length */
    defaultPageLength: 50,
    /** Search debounce time (in ms) */
    searchDebounceTime: 300
  };

  public static queryStringLanguageIds = {
    /** Language ID for query string list page editor */
    queryStringLanguage: 'queryStringLanguage',
    myCustomLanguage: 'myCustomLanguage'
  };

  // SVG paths
  public static svgPaths = {
    whereUsed: {
      default: 'assets/images/svg/where_used.svg',
      transparent: 'assets/images/svg/where_used_transparent.svg'
    }
  };

  // Regex patterns for variable/placeholder matching
  public static variablePatternTest = /^\$\{.*\}$/;
  public static variablePatternExact = /^\$\{(.*)\}$/;
  public static variablePatternGlobal = /\$\{([^}]*)\}/g;
  public static bomPattern = /\uFEFF/g;

  // Pagination constants for document component
  public static rowsPerPageOptions = [10, 20, 50];
}
